import { type IAction } from './models';
import { SimpleDataProvider } from '../data-provider';

class DataProviderRegister {
    private providers: SimpleDataProvider[];

    constructor() {
        this.providers = [];
    }

    public subscribe(provider: SimpleDataProvider) {
        if (!provider) {
            return;
        }

        const index = this.providers.findIndex(item => {
            return item === provider;
        });

        if (index === -1) {
            this.providers.push(provider);
        }
    }

    public unsubscribe(provider: SimpleDataProvider) {
        if (!provider) {
            return;
        }

        const index = this.providers.findIndex(item => {
            return item === provider;
        });

        if (index !== -1) {
            this.providers.splice(index, 1);
        }
    }

    /**
     * Notify data providers about changes
     */
    public notify(action: IAction, strict: boolean = false) {
        if (!action || !action.hash) {
            return;
        }
        const hashes: string[] = [];
        let path = action.hash;
        if (strict) {
            hashes.push(path);
        } else {
            let protocol = '';
            if (action.hash.indexOf('://')) {
                const parts = action.hash.split('://');
                protocol = parts[0] + '://';
                path = parts[1] || '';
            }
            const parts = path.split('/');
            parts.forEach((part, i) => {
                if (i === 0) {
                    hashes.push(protocol + part);
                } else {
                    hashes.push(hashes[i - 1] + '/' + part);
                }
            });
            hashes.reverse();
        }

        for (let i = 0; i < hashes.length; i++) {
            const hash = hashes[i];
            let path = hash.replace(/\/\d+/gi, '/{}');
            path = path.replace(/\/\{}$/gi, '');
            this.providers.forEach(provider => {
                if (provider.isServicePath(path) || provider.isServicePath(path + '/{}')) {
                    provider.fire(hash, action);
                }
            });
        }
    }
}

class DataProviderListener {}

// private packet export
export const register = new DataProviderRegister();
